const popupButtons = document.querySelectorAll(".popup-button");
const popupOverlays = document.querySelectorAll(".popup-overlay");
const closeButtons = document.querySelectorAll(".close-button");
const geolocation_backdrop = document.querySelector("#geolocation_backdrop");

popupButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    const popup = e.target.closest(".popup-button").nextElementSibling;
    popup.style.display = "block";
    const popupOverlay = popup.nextElementSibling;
    popupOverlay.style.display = "block";
    console.log("Geolocation button clicked");
    const geolocation_backdrop = document.querySelector("#geolocation_backdrop");
    geolocation_backdrop.style.display = "block";
  });
});

popupOverlays.forEach((overlay) => {
  overlay.addEventListener("click", (e) => {
    const popup = e.target.closest(".popup-overlay").previousElementSibling;
    popup.style.display = "none";
    const popupOverlay = e.target.closest(".popup-overlay");
    popupOverlay.style.display = "none";
  });
});

function getCountryURL(countryName) {
  switch (countryName) {
    case "Denmark":
      return "https://otay.dk/";
    default:
      return "https://otay.dk/";
  }
}

function setLinks() {
  const elements = document.querySelectorAll("a.button_country");
  const pathname = window.location.pathname;

  elements.forEach((element) => {
    const country = element.getAttribute("data-country");
    let href;

    switch (country) {
      case 'dk':
        href = "https://otay.dk" + pathname;
        break;
      case 'no':
        href = "https://otay.no" + pathname;
        break;
      case 'eu':
        href = "https://otay.eu" + pathname;
        break;
      default:
        // Handle unrecognized country
        href = "#";
        break;
    }
    element.href = href;
  });
}

function showCountry() {
  closeModal();

  const url = "https://ipapi.co/json";

  fetch(url)
    .then((response) => response.json())
    .then((data) => {
      const countryName = data.country_name;
      const countryURL = getCountryURL(countryName);
      const windowURL = window.location.href;

      if (windowURL.includes(countryURL)) {
        // Hide the modal
        const modals = document.querySelectorAll(".popup");
        modals.forEach((modal) => {
          modal.style.display = "none";
        });

        const popupOverlays = document.querySelectorAll(".popup-overlay");
        popupOverlays.forEach((popupOverlay) => {
          popupOverlay.style.display = "none";
        });
      } else {
        const hasShownPopup = localStorage.getItem(
          "MERCIVE_GeolocationSwitch_hasShownPopup"
        );

        if (hasShownPopup === null) {
          localStorage.setItem("MERCIVE_GeolocationSwitch_hasShownPopup", true);
          // Display the modal with country options
          const modals = document.querySelectorAll(".popup");
          modals.forEach((modal) => {
            modal.style.display = "block";
          });

          const popupOverlays = document.querySelectorAll(".popup-overlay");
          popupOverlays.forEach((popupOverlay) => {
            popupOverlay.style.display = "block";
          });
        } else {
          // Hide the modal
          const modals = document.querySelectorAll(".popup");
          modals.forEach((modal) => {
            modal.style.display = "none";
          });

          const popupOverlays = document.querySelectorAll(".popup-overlay");
          popupOverlays.forEach((popupOverlay) => {
            popupOverlay.style.display = "none";
          });
        }
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

function closeModal() {
  let modals = document.querySelectorAll(".popup");
  modals.forEach((modal) => {
    modal.style.display = "none";
  });

  let popupOverlays = document.querySelectorAll(".popup-overlay");
  popupOverlays.forEach((popupOverlay) => {
    popupOverlay.style.display = "none";
  });
}

showCountry();
setLinks();
